import { render } from "./choiceSpace.vue?vue&type=template&id=121fde9a&scoped=true&ts=true"
import script from "./choiceSpace.vue?vue&type=script&lang=ts"
export * from "./choiceSpace.vue?vue&type=script&lang=ts"

import "./choiceSpace.vue?vue&type=style&index=0&id=121fde9a&lang=scss&scoped=true"
import "./choiceSpace.vue?vue&type=style&index=1&id=121fde9a&lang=scss"

import exportComponent from "/Users/wangyong/shanggeyun/code/sagacloud-sagacare-ipad/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121fde9a"]])

export default __exports__